import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Animation that represents a loading process.
 */
@Component({
    selector: 'ush-dots-loader',
    templateUrl: './dots-loader.component.html',
    styleUrls: ['./dots-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DotsLoaderComponent {
  /**
   * Aplied to background style prop.
   */
  @Input() dotsColor?: string;
}
